<h2 mat-dialog-title>{{ 'New condition' | translate }}</h2>
<mat-dialog-content>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Select source' | translate }}</div>
    <select [(ngModel)]="selectedComponent" inactif matNativeControl>
      <option *ngFor="let source of possibleSources" [value]="source.id">{{ source.title !== null && source.title !== undefined && source.title !== "" ? source.title : source.config?.placeholder !== "" ? source.config?.placeholder : source.config?.text }}</option>
    </select>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="!selectedComponent">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
